"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayWithOpponentAction = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@dp-instant/core");
var interfaces_1 = require("@dp-instant/interfaces");
var social_1 = require("@dp-instant/social");
var inversify_1 = require("inversify");
var __1 = require("..");
var PlayWithOpponentAction = (function (_super) {
    tslib_1.__extends(PlayWithOpponentAction, _super);
    function PlayWithOpponentAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PlayWithOpponentAction.prototype.execute = function (idOrOpponent) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var status;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.social.playWith(idOrOpponent, true)];
                    case 1:
                        status = _a.sent();
                        if (!(status === social_1.SOCIAL_POPUP.ACCEPTED)) return [3, 3];
                        return [4, this.levelStart.run()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2];
                }
            });
        });
    };
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesSocial.model),
        tslib_1.__metadata("design:type", Object)
    ], PlayWithOpponentAction.prototype, "social", void 0);
    tslib_1.__decorate([
        (0, inversify_1.inject)(interfaces_1.TypesFlow.LevelStart),
        tslib_1.__metadata("design:type", __1.LevelStartAction)
    ], PlayWithOpponentAction.prototype, "levelStart", void 0);
    return PlayWithOpponentAction;
}(core_1.Action));
exports.PlayWithOpponentAction = PlayWithOpponentAction;
//# sourceMappingURL=PlayWithOpponentAction.js.map